import { useEffect } from "react"
import { cn } from "@/lib/utils"
import { UnitTypeGroups } from "@/components/rent/unit-type-groups"
import { UnitTypeDetail } from "@/components/rent/unit-type-detail"
import type { UnitType } from "@/types/warehouse"

type BoxStepProps = {
  isActive: boolean
  isMobile: boolean
  facilityCode?: string | null
  unitTypes: UnitType[]
  occupiedUnitTypes?: UnitType[]
  selectedUnitTypeCode: string | null
  onUnitTypeChange: (code: string | null) => void
  selectedUnitType?: UnitType
  capabilities: string[]
  unitTypeDetailRef: React.RefObject<HTMLDivElement | null>
  footer?: React.ReactNode
}

export function BoxStep({
  isActive,
  isMobile,
  facilityCode,
  unitTypes,
  occupiedUnitTypes = [],
  selectedUnitTypeCode,
  onUnitTypeChange,
  selectedUnitType,
  capabilities,
  unitTypeDetailRef,
  footer,
}: BoxStepProps) {
  useEffect(() => {
    if (!isActive || !isMobile || !selectedUnitTypeCode) {
      return
    }

    const timeoutId = window.setTimeout(() => {
      unitTypeDetailRef.current?.scrollIntoView({ behavior: "smooth", block: "start" })
    }, 0)

    return () => window.clearTimeout(timeoutId)
  }, [isActive, isMobile, selectedUnitTypeCode, unitTypeDetailRef])

  return (
    <div className={cn("flex gap-2", isMobile ? "min-h-0 flex-col" : "h-full min-h-0")}>
      <div
        className={cn(
          "relative shrink-0 rounded-[8px] bg-card",
          !isMobile && "h-full min-h-0 flex-[58%] overflow-y-auto",
        )}
      >
        <UnitTypeGroups
          facilityCode={facilityCode}
          unitTypes={unitTypes}
          occupiedUnitTypes={occupiedUnitTypes}
          value={selectedUnitTypeCode}
          onValueChange={onUnitTypeChange}
        />
      </div>
      {(!isMobile || selectedUnitTypeCode) && (
        <div
          ref={unitTypeDetailRef}
          className={cn(
            "relative scroll-mt-2 rounded-[8px] bg-card p-4 lg:p-8",
            isMobile ? "shrink-0" : "h-full min-h-[480px] grow flex-[42%]",
          )}
        >
          <UnitTypeDetail
            className="h-full"
            facilityCode={facilityCode}
            unitType={selectedUnitType}
            capabilities={capabilities}
          />
          {footer}
        </div>
      )}
    </div>
  )
}
